import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import moment, { Moment } from "moment";
import { FC, memo } from "react";
import MaterialAvatar from "../general/MaterialAvatar";

interface ScoringFeedbackHeaderProps {
    date?: Moment;
    user?: {
        name?: string;
        username?: string;
        email?: string;
        photoURL?: string;
    };
    periodIndex?: number;
}

const ScoringFeedbackHeader: FC<ScoringFeedbackHeaderProps> = (props) => {
    const { date, user, periodIndex } = props;
    const theme = useTheme();
    return (
        <Stack
            direction="row"
            sx={{ alignItems: "center" }}
            spacing={1}
        >
            {!!user && (
                <Tooltip
                    title={
                        <Stack>
                            <Typography>Username: {user?.username}</Typography>
                            <Typography>Email: {user?.email}</Typography>
                        </Stack>
                    }
                >
                    <Box>
                        <MaterialAvatar user={user} />
                    </Box>
                </Tooltip>
            )}
            <Stack
                direction="row"
                spacing={3}
                sx={{ alignItems: "center" }}
            >
                {!!user && <Box sx={{ fontWeight: 700 }}>{user?.name}</Box>}
                <Stack
                    direction="row"
                    sx={{
                        border: `1px solid ${theme?.custom?.mainButtonHighlight}`,
                        backgroundColor: theme?.custom?.white,
                        color: theme?.custom?.mainButtonHighlight,
                        padding: "6px 12px",
                        borderRadius: "4px",
                        fontSize: "14px",
                        alignItems: "center",
                        lineHeight: 1,
                    }}
                >
                    <AccessTimeOutlinedIcon
                        sx={{ marginRight: "4px", fontSize: "18px" }}
                    />
                    {periodIndex !== undefined && (
                        <>
                            <Box sx={{ fontWeight: 700 }}>Week {periodIndex + 1}</Box>
                            &nbsp; - &nbsp;
                        </>
                    )}
                    <Box sx={{ letterSpacing: "1px" }}>{date.format("M[/]D[/]YY")}</Box>
                </Stack>
            </Stack>
        </Stack>
    );
};

ScoringFeedbackHeader.defaultProps = {
    date: moment(),
    user: null,
};

export default memo(ScoringFeedbackHeader);
